import { Component, OnInit , ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConsentService } from '../consent.service';
import { AnalyticsService } from '../analytics.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBannerComponent implements OnInit {

  showBanner = false;
  showCustomize = false;

  consent = {
    analytics: true,
    marketing: false,
  };

  constructor(
    private consentService: ConsentService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.showBanner = !this.consentService.hasConsented();
   
  }

  toggleCustomize(): void {
    this.showCustomize = !this.showCustomize;
  }

  acceptAll(): void {
    this.consentService.saveConsent(true, true);
    this.analyticsService.trackEvent({
      page: 'landing',
      action: 'cookie-accepted-all',
      source: 'landing'
    });
    this.closeBanner();
  }

  rejectAll(): void {
    this.consentService.saveConsent(false, false);
    this.analyticsService.trackEvent({
      page: 'landing',
      action: 'cookie-rejected',
      source: 'landing'
    });
    this.closeBanner();
  }

  saveCustom(): void {
    this.consentService.saveConsent(this.consent.analytics, this.consent.marketing);
    if (this.consent.analytics) {
      this.analyticsService.trackEvent({
        page: 'landing',
        action: 'cookie-custom-saved',
        source: 'landing'
      });
    }
    this.closeBanner();
  }

  private closeBanner(): void {
    this.showBanner = false;
    this.showCustomize = false;
  }
}